import React, { Fragment, useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo-hooks';

import ActSearchCard from '../../components/ActSearchCard';

import BaseModal from '../../components/modals/BaseModal';
import AddActSearchModal from '../../components/modals/AddActSearchModal';

const ACT_QUERY = gql`
  query Act($name: String!) {
    act(name: $name) {
      id
      name
      searches {
        id
        act {
          id
          name
        }
        name
        lang
        concepts {
          id
          index
          json
        }
      }
    }
  }
`;

const Act = props => {
  const { name: actName } = props.match.params;
  const [state, setState] = useState({
    modals: {
      addActSearch: false,
      editActSearch: false
    }
  });

  const { loading, error, data, refetch } = useQuery(ACT_QUERY, {
    fetchPolicy: 'cache-then-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      name: actName
    }
  });

  if (error) {
    return null;
  }

  if (loading) {
    return (
      <div className="act">
        <div className="act-header">
          <div className="act-header-title">Speech Act</div>
        </div>
      </div>
    );
  }

  const showAddActSearchModal = e => {
    e.preventDefault();

    setState(state => ({
      modals: {
        ...state.modals,
        addActSearch: true
      }
    }));
  };

  const hideAddActSearchModal = () => {
    setState(state => ({
      modals: {
        ...state.modals,
        addActSearch: false
      }
    }));
  };

  return (
    <div className="act">
      <div className="act-header">
        <div className="act-header-title">Speech Act: {data.act?.name}</div>
        <div className="act-header-actions">
          <div className="act-header-action" onClick={showAddActSearchModal}>
            Lisää Tunnistus
          </div>
        </div>
      </div>
      <div className="act-info">
        <h2>Tunnistukset</h2>
        <div className="act-searches">
          {data &&
            data.act &&
            data.act.searches
              .sort((a, b) => a.id - b.id)
              .map(search => {
                try {
                  const parsedSearch = {
                    ...search,
                    concepts: search.concepts.map(
                      ({ __typename, ...concept }) => ({
                        ...concept,
                        json: JSON.parse(concept.json)
                      })
                    )
                  };
                  return (
                    <Fragment key={parsedSearch.id}>
                      <ActSearchCard key={parsedSearch.id} {...parsedSearch} />
                      <div className="act-search-debug">
                        {parsedSearch.concepts.map(({ id, ...concept }) => (
                          <div key={id} className="act-search-debug-item">
                            {JSON.stringify(concept.json)}
                          </div>
                        ))}
                      </div>
                    </Fragment>
                  );
                } catch (e) {
                  return (
                    <div key={search.id}>{JSON.stringify(search.concepts)}</div>
                  );
                }
              })}
        </div>
      </div>
      {state.modals.addActSearch && (
        <BaseModal maxWidth={576} minWidth={340}>
          <AddActSearchModal
            act={data.act}
            closeModal={hideAddActSearchModal}
          />
        </BaseModal>
      )}
    </div>
  );
};

export default Act;
